<div class="loader-content">
  <app-ellipsis-loading></app-ellipsis-loading>
</div>
